import { changeClass } from '../change-class';
import { hasClass } from '../has-class';

export function toggleClass(
	element: Element,
	className: string,
	state?: boolean
) {
	changeClass(
		element,
		className,
		state === undefined ? !hasClass(element, className) : state
	);
}
